module.exports = __webpack_public_path__ + "static/media/galdinsPlayed_500_1000.384ddf64.png";